import { useRouter } from 'next/router'

interface TitleBarProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string
  right?: JSX.Element
  rightClass?: string
}

const TitleBar = ({
  title,
  right,
  rightClass = 'w-8',
  ...attributes
}: TitleBarProps): JSX.Element => {
  const router = useRouter()

  const back = (event) => {
    event.preventDefault()
    router.back()
  }

  return (
    <div className="lg:hidden">
      <div {...attributes}>
        <div className="px-4 h-11 items-center flex">
          <div className="w-8">
            <a className="w-6 h-6" onClick={back}>
              <svg
                className="h-6"
                xmlns="https://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </a>
          </div>
          <div className="flex-grow text-center font-bold text-lg">
            {title && <h1>{title}</h1>}
          </div>
          <div className={rightClass}>{right}</div>
        </div>
      </div>
    </div>
  )
}

export default TitleBar
